import { useLang } from "../i18n";
import { SERVICES } from "../data/site";
import Seo, { breadcrumbLd } from "../components/Seo";
import { Reveal, Kicker } from "../components/Reveal";
import ServiceCard from "../components/ServiceCard";

export default function ServicesPage() {
  const { lang, t } = useLang();
  const prefix = lang === "ca" ? "/ca" : "";

  return (
    <div data-testid="services-page" className="pt-32">
      <Seo
        title={t("seo.services.title")}
        desc={t("seo.services.desc")}
        path="/servicios"
        jsonLd={breadcrumbLd([
          { name: "EcoGlow Detailing", path: prefix || "/" },
          { name: t("nav.services"), path: `${prefix}/servicios` },
        ])}
      />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <Reveal><Kicker>{t("servicesPage.kicker")}</Kicker></Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-4 max-w-3xl font-display text-4xl font-black uppercase tracking-tight text-white sm:text-5xl lg:text-6xl">
            {t("servicesPage.title")}
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-400">{t("servicesPage.sub")}</p>
        </Reveal>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-24">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 0.08}>
              <ServiceCard service={s} index={i} />
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
